import { useRef } from 'react';
import { InternalTooltip, useDefaultTooltipConnector } from 'react-rainbow-components';
import InfoIcon from 'components/icons/info';
import { BaseBoardProps, ColumnInfoProps } from '../types';
import { StyledButtonIcon } from './styled';

export interface ColumnInfoButtonProps extends ColumnInfoProps {
    columInfoComponent: BaseBoardProps['columnInfoComponent'];
}

const ColumnInfoAction = ({
    column,
    cards = [],
    columInfoComponent: InfoComponent = () => null,
}: ColumnInfoButtonProps) => {
    const triggerRef = useRef();
    const tooltipRef = useRef();
    const {
        onMouseEnter,
        onMouseLeave,
        onBlur,
        isVisible,
    } = useDefaultTooltipConnector({
        tooltipRef,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        triggerRef: () => triggerRef.current.htmlElementRef,
    });

    return (
        <div
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onBlur={onBlur}
        >
            <StyledButtonIcon
                ref={triggerRef}
                variant="base"
                borderRadius="semi-square"
                size="small"
                icon={<InfoIcon />}
            />
            <InternalTooltip
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                triggerElementRef={() => triggerRef.current.htmlElementRef}
                ref={tooltipRef}
                preferredPosition="top"
                isVisible={isVisible}
            >
                <InfoComponent column={column} cards={cards} />
            </InternalTooltip>
        </div>
    );
};

export default ColumnInfoAction;
